import type { FamilyBookPost } from "../lib/familyBook";
import "./journal-entry.css";

const normalize = (value: string) => value.replace(/\s+/g, " ").trim();

// Older journal bodies repeat the structured prompts before the extra writing.
// Remove only that exact generated prefix, never split prose on question marks.
export function journalExtraWriting(post: FamilyBookPost): string {
  const body = post.body || "";
  if (post.journalBodyFormat === "extra") return body;
  const prompts = post.journalPrompts || [];
  if (!prompts.length) return body;
  const prefix = prompts.flatMap(item => [item.prompt, item.answer]).filter(Boolean).join("\n\n");
  const normalizedBody = normalize(body);
  const normalizedPrefix = normalize(prefix);
  if (!normalizedPrefix) return body;
  if (normalizedBody === normalize(prefix.slice(0, 2000))) return "";
  if (normalizedBody === normalizedPrefix) return "";
  if (normalizedBody.startsWith(normalizedPrefix + " ")) {
    return normalizedBody.slice(normalizedPrefix.length).trim();
  }
  // Preserve unfamiliar/older body formats in full rather than guessing.
  return body;
}

export function JournalEntryContent({ post }: { post: FamilyBookPost }) {
  const prompts = (post.journalPrompts || []).filter(item => item.answer.trim());
  const extra = journalExtraWriting(post);
  return <div className="journal-entry-content">
    {prompts.map((item, index) => <section className="journal-entry-response" key={item.key + "-" + index}>
      {prompts.length > 1 && <span className="journal-entry-label">Question {index + 1}</span>}
      <h3>{item.prompt}</h3>
      <p>{item.answer}</p>
    </section>)}
    {extra.trim() && <section className="journal-entry-extra">
      <h3>More from today</h3>
      <p>{extra}</p>
    </section>}
  </div>;
}
